import { Component, ojs, app, each, state, component, v } from "modular-openscriptjs";
import { pageInfo, either, inform } from "../../helpers";
import { dom } from "../../fotastart";
import { PAGES, STRINGS, uc } from "../../declarations";
import Card from "../Blocks/Card";
import SettingItem from "../SettingItem";
import { Capacitor } from "@capacitor/core";
import { PushNotifications } from "@capacitor/push-notifications";

const h = app("h");
const broker = app("broker");
const $e = app("$e");

ojs(Card, SettingItem);

export default class Setting extends Component {
    notificationGranted = state(false);

    constructor() {
        super();
        this.notificationGranted.listener(this);
    }

    render(...args) {
        pageInfo(PAGES.SETTINGS);

        return h.div(
            { class: "py-5" },

            h.Card(
                {
                    body: [
                        v(this.notificationGranted, (granted) =>
                            h.CheckYesno(
                                {
                                    id: `settings-turn-on-notification`,
                                    role: "switch",
                                    checked: granted.value,
                                    label: {
                                        value: "Receive App Notifications",
                                        class: "fw-medium",
                                    },
                                    helpText: {
                                        value: "Receive notifications for order information, completion codes, app changes, and others",
                                        class: "text-muted small",
                                    },
                                    onchange: this.method("turnOnNotification"),
                                },
                                {
                                    class: "check-yesno-end d-flex justify-content-between align-items-center w-100",
                                },
                            )
                        ),
                    ],
                },
                { class: "mb-4 shadow-sm border-0" },
            ),

            h.call(() => {
                const settings = uc.settings;
                return each(settings.value, (setting) =>
                    h.SettingItem(setting, { class: "mb-4 shadow-sm border-0" }),
                );
            }),

            ...args,
        );
    }

    $_mounted(componentId) {
        let c = component(componentId);
        if (c) {
            c.checkNotificationPermission();
        }
    }

    async checkNotificationPermission() {
        if (Capacitor.isNativePlatform()) {
            try {
                const status = await PushNotifications.checkPermissions();
                this.notificationGranted.value = (status.receive === "granted");
            } catch (e) {
                console.error("Failed to check push notification permissions", e);
                this.notificationGranted.value = false;
            }
        } else {
            this.notificationGranted.value = (
                "Notification" in window &&
                Notification.permission === "granted"
            );
        }
    }

    async turnOnNotification() {
        if (Capacitor.isNativePlatform()) {
            try {
                let permStatus = await PushNotifications.checkPermissions();
                if (permStatus.receive === "granted") {
                    this.notificationGranted.value = true;
                    return;
                }
                broker.send($e.system.needs.notificationPermission);
            } catch (e) {
                console.error("Failed to turn on push notifications", e);
            }
        } else {
            if (
                !("Notification" in window) ||
                Notification.permission === "granted"
            )
                return;

            broker.send($e.system.needs.notificationPermission);
        }
    }

    $$system = {
        has: {
            notificationPermission: (ed, event) => {
                if (Capacitor.isNativePlatform()) {
                    this.notificationGranted.value = true;
                    if (dom.id("settings-turn-on-notification")) {
                        dom.id("settings-turn-on-notification").checked = true;
                    }
                    return;
                }

                if (!("Notification" in window)) return;
                if (!dom.id("settings-turn-on-notification")) return;

                if (Notification.permission === "granted") {
                    this.notificationGranted.value = true;
                    dom.id("settings-turn-on-notification").checked = true;
                    return;
                }

                if (Notification.permission === "denied") {
                    inform(
                        "Oops! Notification is blocked. Please use chrome site settings to reset it",
                        STRINGS.WARNING,
                    );
                }

                this.notificationGranted.value = false;
                dom.id("settings-turn-on-notification").checked = false;
            },
        },
    };
}

ojs(Setting);
